/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import _ from 'lodash';

import AttachmentCardsCollectionView from '../../../common/views/AttachmentCardsCollectionView/AttachmentCardsCollectionView';

import tmplOrderPackageAttachmentsView from './OrderPackageAttachmentsView.hbs';

const OrderPackageAttachmentsView = View.extend({
  template: tmplOrderPackageAttachmentsView,

  className: 'order-package-attachements-view',

  ui: {
    attachments: '.attachments'
  },

  regions: {
    attachments: '@ui.attachments'
  },

  onRender() {
    const numOfAttachments = this.model.get('attachments').orders.length;
    _.each(this.model.get('attachments').orders, (orderAttachments, index) => {
      orderAttachments.documentTypes = this.model.get('documentTypes');
      if (index === numOfAttachments - 1) {
        orderAttachments.lastOrder = true;
      }
    });
    const collection = new Backbone.Collection(this.model.get('attachments').orders);
    _.each(collection.models, (model) => model.set('isReadOnly', !this.model.get('editable')));
    // _.each(collection.models, (model) => model.set('isSpecialtyRequirementEditable', this.isSpecialtyRequirementEditable()));

    this.attachmentsCollectionView = new AttachmentCardsCollectionView({
      collection
    });
    this.showChildView('attachments', this.attachmentsCollectionView);
  }
});

export default OrderPackageAttachmentsView;
